import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';

@Component({
  selector: 'app-organizeform',
  templateUrl: './organizeform.component.html',
  styleUrls: ['./organizeform.component.scss']
})
export class OrganizeformComponent implements OnInit {

  orgForm!: FormGroup;
  countries: any = [];
  states: any = [];
  cities: any = [];
  businessTypes: any = [];
  countriesCode: any = []
  organizer: any
  designT: any = [];
  public formfillNext: boolean = false;
 isEditMode = false;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _ds: DataService,
    private enc: EncryptionService,
    private router: Router,
    private organizerSession: OrganizerSessionService
  ) {
    let data = localStorage.getItem('user');
    this.organizer = data ? JSON.parse(data) : null;
  }

  ngOnInit(): void {

    // this._ds.getUniqueUserData()
    this.orgForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],   // 🔥 add this

      email: [this.organizer.email],

      countryCode: [null, Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(6),
      Validators.maxLength(15)]],

      designation: [null, Validators.required],
      organization_name: ['', Validators.required],

      website: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(https?:\/\/)(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/)
        ]
      ],   // agar chahe toh URL/email pattern bhi laga deta hoon

      businessType: [null, Validators.required],

      country: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
    });


    this.getAllcountries();
    this.getAllbusinessType();
    this.getAllcountryCode();
    this.getAllDesignation();

    // 🔥 CountryCode → Country sync
    this.orgForm.get('countryCode')?.valueChanges.subscribe(code => {

      if (this.isEditMode) return;

      const selectedCode = this.countriesCode.find(
        (c: any) => c.phonecode == code
      );

      if (!selectedCode) return;

      const matchedCountry = this.countries.find(
        (c: any) => c.id == selectedCode.id
      );

      if (!matchedCountry) return;

      this.orgForm.patchValue(
        {
          country: matchedCountry.name,
          state: null,
          city: null
        },
        { emitEvent: false }
      );

      this.states = [];
      this.cities = [];

      this.getAllstates(matchedCountry.id);
    });



    // 🔥 Country → CountryCode sync
    this.orgForm.get('country')?.valueChanges.subscribe(countryName => {
      if (this.isEditMode) return;
      const selectedCountry = this.countries.find(
        (c: any) => c.name == countryName
      );

      if (!selectedCountry) return;

      const matchedCode = this.countriesCode.find(
        (c: any) => c.id == selectedCountry.id
      );

      if (!matchedCode) return;

      this.orgForm.patchValue(
        {
          countryCode: matchedCode.phonecode,
          state: null,
          city: null
        },
        { emitEvent: false }
      );

      this.states = [];
      this.cities = [];

      this.getAllstates(selectedCountry.id);
    });



    // 🔥 State → City load
    this.orgForm.get('state')?.valueChanges.subscribe(stateName => {
if (this.isEditMode) return;
      const selectedState = this.states.find(
        (s: any) => s.name == stateName
      );

      if (!selectedState) return;

      this.orgForm.patchValue(
        { city: null },
        { emitEvent: false }
      );

      this.cities = [];

      this.getAllcities(selectedState.id);
    });

    this.route.queryParams.subscribe(params => {
      const id = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/organiser',
        this.router
      );
      if (id == null) return;
      this.isEditMode = true;
      this.formfillNext = true

      this._ds.getUniqueUserData(id).subscribe((res: any) => {
        const allData = this.enc.decrypt(res.data);

        const selectedNames = allData.organizer;
        console.log(selectedNames)
        const cleanNumber = allData.organizer.phone.replace('+', '');
        const parts = cleanNumber.split(' ');

        // 2. Variables mein store karo
        const countryCode = parts[0]; // Isme "+91" aayega
        const mobileNumber = parts[1]; // Isme "9045444416" aayega


        setTimeout(() => {
          this.orgForm.patchValue({
            firstName: allData.organizer.first_name,
            lastName: allData.organizer.last_name,
            countryCode: countryCode,
            phone: mobileNumber,
            email: allData.organizer.email,
            designation: allData.organizer.designation,
            organization_name: allData.organizer.company_name,
            website: allData.organizer.website,
            businessType: allData.organizer.business_type,
            country: allData.organizer.country,
            state: allData.organizer.state,
            city: allData.organizer.city,

          });
          Object.keys(this.orgForm.controls).forEach(key => {
            this.orgForm.get(key)?.disable();
          });
          this.isEditMode = false;
        }, 500);
      });
    });

  }


  // getAllcountryCode() {
  //   this._ds.allCountryCode().subscribe((res) => {
  //     const decryptedData = this.enc.decrypt(res.data);
  //     this.countriesCode = decryptedData.data;
  //     console.log('✅ Decrypted response:', decryptedData);
  //   })
  // }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getAllcountryCode() {
    this._ds.allCountryCode().subscribe((res) => {
      const decryptedData = this.enc.decrypt(res.data);
      this.countriesCode = decryptedData.data;
      console.log('✅ Decrypted response:', decryptedData);

      // 🇮🇳 India ko by default select karo
      const india = this.countriesCode.find(
        (c: any) => c.phonecode === '91' || c.name === 'India'
      );

      if (india) {
        this.orgForm.patchValue({
          countryCode: india.phonecode   // 👈 id set karni hai
        });
      }
    });
  }

  submitted = false;

  submit() {
    this.submitted = true;
    this.orgForm.markAllAsTouched();   // 🔥 submit pe sab error show

    if (this.orgForm.invalid) {
      return;  // ❌ yahin se API call ruk jayegi
    }

    const form = this.orgForm.value;

    const payload = {
      organizer_type: 'organization',
      work_email: form.email,
      first_name: form.firstName,
      last_name: form.lastName,
      designation: form.designation,
      phone: `+${form.countryCode} ${form.phone}`,
      organization_name: form.organization_name,
      website: form.website,
      business_type: form.businessType,
      estimate_year: form.eventsPerYear,
      country: form.country,
      state: form.state,
      city: form.city,
    };

    this._ds.createOrganizer(payload).subscribe({
      next: (res) => {
        if (res?.data) {
          const decryptedData = this.enc.decrypt(res.data);
          localStorage.setItem('organizer', JSON.stringify(decryptedData));
          if (decryptedData?.jwt_token) {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            user.jwt_token = decryptedData.jwt_token;
            localStorage.setItem('user', JSON.stringify(user));
            this._ds.getDiorToken();
          }
          this.router.navigate(['/event-information']);
        }
      },
      error: (err) => {
        if (err?.error?.data) {
          const decryptedData = this.enc.decrypt(err.error.data);

          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });

          Toast.fire({ title: decryptedData.error });
        }
      }
    });
  }

  getAllcountries() {
    this._ds.allCountry().subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.countries = decryptedData.data;
    })
  }

  getAllDesignation() {
    this._ds.allDesignation().subscribe((res) => {
      const decryptedData = this.enc.decrypt(res.data);
      this.designT = decryptedData.data;
      console.log(this.designT)

    })
  }

  getAllbusinessType() {
    this._ds.allBusinessType().subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.businessTypes = decryptedData.data;
      console.log(this.businessTypes)
    })
  }

  onCountryChange(countryId: any) {
    console.log(countryId);
    this.getAllstates(countryId.id);
  }

  onStateChange(stateId: any) {
    this.getAllcities(stateId.id);
  }

  getAllcities(id: any) {
    this._ds.allCities(id).subscribe((res) => {

      const decryptedData = this.enc.decrypt(res.data);
      this.cities = decryptedData.data;
      console.log('✅ Decrypted response:', decryptedData);
    })
  }

  getAllstates(id: any) {
    this._ds.allState(id).subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.states = decryptedData.data;
      console.log('✅ Decrypted response:', decryptedData);
    })
  }

  next() {
    const id = this.organizerSession.getSessionOrganizerId();
    if (id == null) return;
    this.router.navigate(['/event-information'], { queryParams: { id } });
  }

  numberOnly(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;

  // Allow only 0-9
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}

}
